import dict from '../../../scripts/static-data/i18n/th/dictionary.json';
import { LocalDictionaryProvider } from './provider';

const provider = new LocalDictionaryProvider((dict as unknown) as Record<string, string>);

export const translateText = (t?: string, ctx?: string) => (t ? (provider.translate(t, { contextKey: ctx }) as string) : '');
export const translateHtml = (html?: string, ctx?: string) =>
  html ? (provider.translate(html, { html: true, contextKey: ctx }) as string) : '';

export const translateObject = <T extends Record<string, any>>(obj: T, ctxPrefix: string): T => {
  if (!obj) return obj;
  const entries = Object.entries(obj).map(([k, v]) => {
    if (typeof v === 'string') return [k, translateText(v, `${ctxPrefix}.${k}`)];
    return [k, v];
  });
  return Object.fromEntries(entries) as T;
};
